import React from 'react'

import './styles/loading.css'

import load from "./imgs/load.png";

const Loading = () => {
  return (
    <div className='loading-bg'>
        <div className='loader-container'>
            <img src={ load } className='loading-icon rotate' alt='cargando'/>
        </div>
    </div>
  )
}

export default Loading